import { FrontendLocations, useFrontendSubscriptionStatus } from '@cmctechnology/webinvest-store-frontend';
import isEqual from 'lodash.isequal';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ApiRequest } from '../models/apiRequest';
import { subscribeClientProfileSettings, unsubscribeClientProfileSettings } from '../profileSettingActions';
import { CLIENT_STORE_NAME, IStore } from '../store';
import { ProfileSetting } from '../types';

export const useClientProfileSettings = (location: FrontendLocations, profileSettings: ProfileSetting[]) => {
  const dispatch = useDispatch();
  const profile = useSelector((store: IStore) => store.client.profileSettings);
  const [locationArg, setLocationArg] = useState(location);
  const [profileSettingsArg, setProfileSettingsArg] = useState(profileSettings);
  const [settings, setSettings] = useState<Partial<Record<ProfileSetting, any>>>({});

  useEffect(() => {
    if (location === locationArg && isEqual(profileSettings, profileSettingsArg)) return;

    setLocationArg(location);
    setProfileSettingsArg(profileSettings);
  }, [location, profileSettings]);

  useEffect(() => {
    dispatch<any>(subscribeClientProfileSettings(locationArg, profileSettingsArg));
    return () => {
      dispatch<any>(unsubscribeClientProfileSettings(locationArg, profileSettingsArg));
    };
  }, [locationArg, profileSettingsArg]);

  useEffect(() => {
    const newSettings = Object.assign({}, ...profileSettingsArg.map((ps) => ({ [ps]: profile[ps] }))) as Partial<Record<ProfileSetting, any>>;
    /* istanbul ignore next */
    if (!isEqual(settings, newSettings)) {
      setSettings(newSettings);
    }
  }, [profile]);

  return settings;
};

export const useClientProfileSettingsWithStatus = (location: FrontendLocations, profileSettings: ProfileSetting[]) => {
  const settings = useClientProfileSettings(location, profileSettings);
  const { error, fetching, polling } = useFrontendSubscriptionStatus(CLIENT_STORE_NAME, ApiRequest.ClientProfileSettingGet1);

  return {
    loading: fetching && Object.values(settings).filter((x) => !!x).length === 0,
    polling,
    error,
    data: settings
  };
};
